// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen` from
// x-flags.doRenderReactQueryQueryHook on POST /season/leaderboard-get.

import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import type {
  typeSeasonLeaderboardGetBody,
  typeSeasonLeaderboardGetOutput200,
} from "../../sdk/season/postSeasonLeaderboardGet";
import useCallSdk from "../../sdk-helpers/useCallSdk";

export function buildSeasonLeaderboardGetQueryKey(
  payload: typeSeasonLeaderboardGetBody,
): string[] {
  const queryKeySegments: string[] = [];
  queryKeySegments.push(`poolId:${JSON.stringify(payload.poolId)}`);
  queryKeySegments.push(`seasonId:${JSON.stringify(payload.seasonId)}`);
  return [
    "post:season:seasonLeaderboardGet",
    "svc:contest-api",
    ...queryKeySegments,
  ];
}

type QueryOptions = Partial<
  UseQueryOptions<
    typeSeasonLeaderboardGetOutput200,
    unknown,
    typeSeasonLeaderboardGetOutput200,
    string[]
  >
> & {
  // Isolates two callers that query the same data for independent UI state
  // (e.g. a dropdown search vs a table both listing the same resource).
  queryKeyIdentifier?: string;
};

export default function useSeasonLeaderboardGet(
  payload: typeSeasonLeaderboardGetBody,
  options?: QueryOptions,
) {
  // No staleTime default here on purpose. Freshness is the consuming app's
  // decision and belongs in its QueryClient, in one place: a default set on the
  // hook would silently beat it for every screen. Pass one per call to override.
  const resolvedOptions = options ?? {};

  let queryKey = buildSeasonLeaderboardGetQueryKey(payload);
  if (resolvedOptions.queryKeyIdentifier) {
    queryKey = [...queryKey, resolvedOptions.queryKeyIdentifier];
  }

  const { callSdk } = useCallSdk();
  return useQuery({
    queryKey,
    queryFn: () => callSdk().postSeasonLeaderboardGet(payload),
    ...resolvedOptions,
  });
}
